var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"notif_box"},[_c('div',{class:_vm.typeClass},[_c('span',[_vm._v(_vm._s(_vm.notification.Message))]),_c('i',{staticClass:"fas fa-times"})])])}
var staticRenderFns = []

export { render, staticRenderFns }